import Box from '@mui/material/Box';

import { useStyles } from '../../DataTable.styles';
import type { DataTableCellShell } from '../../DataTable.types';

export interface ResizeHandleProps {
    shell: DataTableCellShell;
    automationId?: boolean;
}

export const ResizeHandle = ({ shell, automationId }: ResizeHandleProps) => {
    const { classes, cx } = useStyles();
    if (shell.isLast) return null;
    const field = shell.column.field;
    const extra = automationId ? { 'automation-id': `resize-${field}` } : {};
    return (
        <Box
            className={cx(classes.resizeHandle, shell.isResizeActive && classes.resizeHandleActive)}
            onMouseDown={(e) => shell.onResizeStart(field, e)}
            onMouseEnter={() => shell.onResizeHover(field)}
            onMouseLeave={() => shell.onResizeHover(null)}
            onClick={(e) => e.stopPropagation()}
            {...extra}
        />
    );
};
